// components/Navbar/navbarElements.js

import { FaBars } from "react-icons/fa";
import { NavLink as NLink } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	background: #333;
	height: 45px;
	display: flex;
	justify-content: space-between;
	z-index: 1000;
`;

export const NavLink = styled(NLink)`
	color: #808080;
	display: flex;
	align-items: center;
	gap: 0.42rem;
	text-decoration: none;
	padding: 0 0.95rem;
	height: 100%;
	cursor: pointer;
	position: relative;
	transition: color 0.18s ease, transform 0.18s ease;

	svg {
		font-size: 0.86rem;
		opacity: 0.78;
		transition: color 0.18s ease, opacity 0.18s ease, transform 0.18s ease;
	}

	&::after {
		content: "";
		position: absolute;
		left: 0.95rem;
		right: 0.95rem;
		bottom: 7px;
		height: 2px;
		border-radius: 999px;
		background: #f5d28a;
		opacity: 0;
		transform: scaleX(0.2);
		transition: opacity 0.18s ease, transform 0.18s ease;
	}

	&.active {
		color: #ffffff;
	}

	&:hover,
	&:focus-visible,
	&.active {
		color: #ffffff;
		transform: translateY(-1px);
		outline: none;
	}

	&:hover svg,
	&:focus-visible svg,
	&.active svg {
		color: #f5d28a;
		opacity: 1;
		transform: translateY(-1px);
	}

	&:hover::after,
	&:focus-visible::after,
	&.active::after {
		opacity: 1;
		transform: scaleX(1);
	}
`;

export const ExternalLink = styled.a`
	color: #808080;
	display: flex;
	align-items: center;
	gap: 0.42rem;
	text-decoration: none;
	padding: 0 0.95rem;
	height: 100%;
	cursor: pointer;
	position: relative;
	transition: color 0.18s ease, transform 0.18s ease;

	svg {
		font-size: 0.86rem;
		opacity: 0.78;
		transition: color 0.18s ease, opacity 0.18s ease, transform 0.18s ease;
	}

	&::after {
		content: "";
		position: absolute;
		left: 0.95rem;
		right: 0.95rem;
		bottom: 7px;
		height: 2px;
		border-radius: 999px;
		background: #f5d28a;
		opacity: 0;
		transform: scaleX(0.2);
		transition: opacity 0.18s ease, transform 0.18s ease;
	}

	&:hover,
	&:focus-visible {
		color: #ffffff;
		transform: translateY(-1px);
		outline: none;
	}

	&:hover svg,
	&:focus-visible svg {
		color: #f5d28a;
		opacity: 1;
		transform: translateY(-1px);
	}

	&:hover::after,
	&:focus-visible::after {
		opacity: 1;
		transform: scaleX(1);
	}
`;

export const MenuButton = styled.button`
	display: none;
	color: #808080;
	background: transparent;
	border: 0;
	padding: 0 20px;
	font-size: 1.5rem;
	cursor: pointer;

	@media screen and (max-width: 900px) {
		display: flex;
		align-items: center;
	}
`;

export const Bars = styled(FaBars)``;

export const NavMenu = styled.div`
	display: flex;
	align-items: center;
	margin-right: 10px;
	white-space: nowrap;

	@media screen and (max-width: 900px) {
		display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
		flex-direction: column;
		align-items: stretch;
		position: absolute;
		top: 45px;
		left: 0;
		width: 100%;
		margin: 0;
		background: #333;

		${NavLink},
		${ExternalLink} {
			box-sizing: border-box;
			justify-content: center;
			width: 100%;
			height: auto;
			padding: 0.85rem 20px;
			border-top: 1px solid #484848;
			text-align: center;

			&::after {
				left: 20px;
				right: 20px;
				bottom: 8px;
			}
		}
	}
`;

export const NavBtn = styled.div`
	display: flex;
	align-items: center;
	margin-right: 20px;
`;

export const NavBtnLink = styled(NLink)`
	padding: 5px 0;
	color: #FFFFFF;
	font-weight: 900;
	outline: none;
	border: 0;
	cursor: pointer;
	transition: color 0.18s ease, transform 0.18s ease;
	text-decoration: none;
	margin-left: 20px;
	display: inline-flex;
	align-items: center;
	white-space: nowrap;

	img {
		width: auto;
		height: 34px;
		object-fit: contain;
		transition: transform 0.18s ease;
	}

	&:hover,
	&:focus-visible,
	&.active {
		color: #f5d28a;
		transform: translateY(-1px);
	}

	&:hover img,
	&:focus-visible img,
	&.active img {
		transform: translateY(-1px);
	}

	@media screen and (max-width: 900px) {
		margin-left: 16px;

		img {
			height: 30px;
		}
	}
`;
